import { routerHelpers } from '@approvalmax/utils';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { showPasswordResetModule } from '../actions';
import { RESET_PASSWORD_PAGE_ID } from '../config';

const useResetPasswordPageData = () => {
    const dispatch = useDispatch();
    const search = useLocation().search;
    const email = routerHelpers.getParamAsString(search, 'email', '');

    useEffect(() => {
        dispatch(showPasswordResetModule({ innerPageId: RESET_PASSWORD_PAGE_ID, email }));
    }, [dispatch, email]);
};

export default useResetPasswordPageData;
